import React, {forwardRef} from 'react'
import {NLPurchasePageBlock} from '../../../nl-purchase-page'
import {HashMap} from '../../../lib/list'
import NLBlock from '../../NLBlock'
import {PageTemplate} from '../../../page-template'
import styles from './Column.module.css'

export interface ColumnProps {
  number: number
  blocks: HashMap<NLPurchasePageBlock>
  template: PageTemplate
}

export default function Column(props: ColumnProps) {
  const {blocks, number, template} = props

  const childBlocks: HashMap<NLPurchasePageBlock> = {}
  for (const [blockId, block] of Object.entries(blocks)) {
    if (block.column === number) {
      childBlocks[blockId] = block
    }
  }

  return (
    <ColumnBox>
      {Object.entries(childBlocks).map(([id, block]) => (
        <NLBlock id={id} key={id} block={block} template={template} />
      ))}
    </ColumnBox>
  )
}

export const ColumnBox = forwardRef(
  (props: {children: React.ReactNode}, ref: React.Ref<HTMLDivElement>) => {
    return (
      <div className={styles.column} ref={ref}>
        {props.children}
      </div>
    )
  },
)
